exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".records {\n  width: 70%;\n  margin: auto;\n  margin-bottom: 25px;\n}\n\n.record-box {\n  position: relative;\n  border: 1px solid #5f5f5f;\n  border-radius: 3px;\n  background-color: #3a3636;\n  margin: 2px;\n}\n\n.selected-record-box {\n  position: relative;\n  border: 1px solid #d50b01;\n  border-radius: 3px;\n  background-color: #3a3636;\n  margin: 2px;\n}\n\n.record-day {\n  text-align: center;\n  height: 40%;\n  font-size: 16px;\n}\n\n.record-icon-time {\n  display: table;\n  height: 60%;\n}\n\n.replay-icon {\n    display: table-cell;\n    width: 28%;\n    padding: 5px;\n    margin-left: 10px;\n    text-align: center;\n    vertical-align: middle;\n    color: white;\n    cursor: pointer;\n}\n\n.record-time {\n    display: table-cell;\n    width: 52%;\n    text-align: center;\n    vertical-align: middle;\n    font-size: 19px;\n    font-weight: bolder;\n}\n\n@media (max-width: 991px) {\n\n .records {\n   width: 99%;\n }\n\n \n\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/btv/channel-detail/channel-detail.component.css
// module id = ../../../../../src/app/views/btv/channel-detail/channel-detail.component.css
// module chunks = main